type Props = {
  size?: number;
  className?: string;
  /** Erişilebilirlik: boş bırakılırsa dekoratif (aria-hidden) */
  title?: string;
};

/**
 * Takvim rezervasyon kutusu — sağ üst: "Ders İptal Edildi".
 * Kaynak: frontend/src/assets/icons/lesson-cancelled.svg
 */
export function LessonCancelledIcon({ size = 18, className, title }: Props) {
  const decorative = !title;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      width={size}
      height={size}
      className={className}
      aria-hidden={decorative ? true : undefined}
      role={decorative ? "presentation" : "img"}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <rect x="3.5" y="5.5" width="17" height="15" rx="3" fill="#ffffff" stroke="#fecaca" strokeWidth="0.75" />
      <path
        d="M3.5 8.5c0-1.66 0-2.49.51-3.01.51-.52 1.34-.52 3.01-.52h9.96c1.67 0 2.5 0 3.01.52.51.52.51 1.35.51 3.01v2h-17v-2z"
        fill="#ef4444"
      />
      <rect x="7.25" y="2.75" width="2.2" height="3.75" rx="1.1" fill="#dc2626" />
      <rect x="14.55" y="2.75" width="2.2" height="3.75" rx="1.1" fill="#dc2626" />
      <path
        d="M5.25 7.25 18.75 20.75"
        stroke="#ef4444"
        strokeWidth="2.75"
        strokeLinecap="round"
      />
    </svg>
  );
}
